import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dochub': {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M397.9 160H256V19.6L397.9 160zM304 192V322C304 388.8 267.5 422.1 190.7 422.1H96V84.8H190.7C202.7 84.8 213.8 85.6 223.8 87.3V3.3C212.9 1.1 201.4 0 189.2 0H0V512H189.2C329.7 512 400 447.4 400 318.1V192H304z'
      }
    ]
  }
})
